import { createContext, useContext } from 'react'

export type QuizMode = 'adult' | 'student' | 'print'

const QuizModeContext = createContext<{ mode: QuizMode }>({ mode: 'adult' })

export const QuizModeProvider = QuizModeContext.Provider
export const useQuizMode = () => useContext(QuizModeContext)
